import { ForwardedRef, forwardRef, ReactNode } from "react"
import cn from "classnames"

import { Icon } from "components"
import { Spinner } from "components/Spinner"

interface Props {
    handleToggle(): void
    toggleOff: boolean
    locked?: boolean
    onIndicator: ReactNode
    offIndicator: ReactNode
    opened?: boolean
    className?: string
    arrow: boolean
}

export const ControlButton = forwardRef(
    (
        {
            handleToggle,
            toggleOff,
            offIndicator,
            onIndicator,
            locked,
            opened,
            className,
            arrow,
        }: Props,
        ref: ForwardedRef<HTMLButtonElement>
    ) => (
        <div className={cn("video-controls__button", { "is-locked": locked }, className)}>
            {locked ? (
                <Spinner className="is-small" />
            ) : (
                <button className="video-controls__icon" onClick={handleToggle} type="button">
                    {toggleOff ? offIndicator : onIndicator}
                </button>
            )}
            {arrow && (
                <button
                    ref={ref}
                    className={cn("video-controls__icon video-controls__selector", {
                        "video-controls__opened": opened,
                    })}
                >
                    <Icon type="arrow-down" size={24} />
                </button>
            )}
        </div>
    )
)

ControlButton.displayName = "ControlButton"
